import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubCustodyAssignment } from 'src/app/models';
import { SubCustodyAssignmentsService } from 'src/app/services/sub-custody-assignments.service';

@Component({
  selector: 'app-sub-custody-assignment',
  templateUrl: './sub-custody-assignments.component.html',
  styles: [],
})
export class SubCustodyAssignmentsComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'partNumber',
      dir: 'asc',
    },
  ]);
  constructor(public dialog: MatDialog, private subCustodyAssignmentsService: SubCustodyAssignmentsService) {}

  ngOnInit() {
    this.loaded$ = this.subCustodyAssignmentsService.loaded$;
    this.filterValue$ = this.subCustodyAssignmentsService.filter$;

    this.gridData$ = combineLatest(this.subCustodyAssignmentsService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([subCustodyAssignments, [sort], skip]) => {
        const data =
          sort.dir === 'asc'
            ? _.sortBy(subCustodyAssignments, sort.field)
            : _.sortBy(subCustodyAssignments, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.subCustodyAssignmentsService.openNewDialog().subscribe();
  }
  openEditDialog(subCustodyAssignment: SubCustodyAssignment) {
    this.subCustodyAssignmentsService.openEditDialog(subCustodyAssignment).subscribe();
  }

  delete(subCustodyAssignment: SubCustodyAssignment) {
    this.subCustodyAssignmentsService.delete(subCustodyAssignment);
  }
  filterSubCustodyAssignments(filter) {
    this.subCustodyAssignmentsService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
